import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AuthConfigService } from 'src/app/modules/auth/auth-config.service';
import { MatMenuTrigger } from '@angular/material/menu';
import { DeviceInfoService } from 'src/app/services/device-info.service';
import { DateTime } from 'ts-luxon';
import { MatDialog } from '@angular/material/dialog';
import { DownloadTypeModalComponent } from "../../modules/device-management/downloadType-modal/downloadType-modal.component"
import { CONSTANTMESSAGE } from "src/app/shared/constants/constants-messages";
import { CANCEL_SYNC_TITLE } from 'src/app/shared/constants/global-constants';
import { getSyncTime } from 'src/app/shared/helpers/helpers';
import { GlobalUtilityService } from 'src/app/shared/services/global-utility.service';

@Component({
  selector: 'ple-header-notification-menu',
  templateUrl: './header-notification-menu.component.html',
  styleUrls: ['./header-notification-menu.component.scss'],
})
export class HeaderNavigationMenuComponent implements OnInit {
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  @ViewChild('showProceedModal') showProceedModal: TemplateRef<any>;
  onDemandData = [];
  syncRequestsInProgress = [];
  onDemandRequestInterval;
  CONSTANTMESSAGE = CONSTANTMESSAGE;
  CANCEL_SYNC_TITLE = CANCEL_SYNC_TITLE;
  cancelSyncRequest;

  constructor(private deviceInfoService: DeviceInfoService, private authConfigService: AuthConfigService,  private dialog: MatDialog, private util: GlobalUtilityService,) {

   
   }

  ngOnInit(): void {
     this.deviceInfoService.getOnDemandSyncInitiate().subscribe(
      res => {
        this.getOnDemandRequests();
    });
    this.getOnDemandRequests();
  }

  ngOnDestroy(): void {
    if(this.onDemandRequestInterval)
      clearInterval(this.onDemandRequestInterval);
  }

  getOnDemandRequests(){
    let tokenPayload = this.authConfigService.getSessionStorage();
    this.deviceInfoService.getOnDemandDataRequests(tokenPayload['sub']).subscribe((response:any) => {
      let formatedResponse = response.map((item)=>{
          let luxonDateTime:any =  DateTime.fromISO(item.tagDataQuery.startTime, {zone: 'utc'});
          item.formattedDate = DateTime.fromISO(item.tagDataQuery?.startTime, {zone: 'utc'}).toFormat("MM/dd/yyyy");
          item.formattedTime = getSyncTime(luxonDateTime._c.hour) + ":" +  getSyncTime(luxonDateTime._c.minute);
          return item;        
      })
      this.onDemandData = this.util.sortArrayOfObjects(formatedResponse, 'syncInitiated').reverse();
      this.syncRequestsInProgress = this.onDemandData.filter((item)=>{
        return item?.syncStatus === 'InProgress';
      })
      if(this.syncRequestsInProgress.length === 0){
        clearInterval(this.onDemandRequestInterval);
      }
      if(this.onDemandData.length === 0){
        this.closeNotifications();
      }
    })
  }

  get badgeClass(): string {
    const length = this.onDemandData.length;
    return length > 999 ? 'badge-large' : length > 99 ? 'badge-medium' : 'badge-small';
  }

  closeNotifications() {
    this.trigger.closeMenu();
    clearInterval(this.onDemandRequestInterval);
  }

  openProceedModal (reqId) {
    let dialogRef = this.dialog.open(this.showProceedModal, {
      width: '650px',
      height: 'max-content',
      disableClose: true
    });

    this.cancelSyncRequest = this.onDemandData.filter((item)=>{
        return item.id === reqId;
    })

  }

  cancelDemandSync(){
    let cancelData = {
      id: this.cancelSyncRequest[0]?.id,
      deviceId: this.cancelSyncRequest[0]?.tagDataQuery.deviceId,
      userId: this.cancelSyncRequest[0]?.userId
    }
    this.deviceInfoService.cancelDemandSyncRequest(cancelData).subscribe((response:any) => {
      this.getOnDemandRequests();
      this.deviceInfoService.setSyncCanceled(true);
    });
  }

  notificationsOpened() {
    this.getOnDemandRequests();
    if(this.syncRequestsInProgress.length > 0){
      this.onDemandRequestInterval = setInterval(() => {
          this.getOnDemandRequests();
      }, 5000);
    }
    this.deviceInfoService.setNotificationsOpen(true);
  }

  notificationsClosed(){
    clearInterval(this.onDemandRequestInterval);
  }

  syncDownload(syncItem){
    let dialogRef = this.dialog.open(DownloadTypeModalComponent, {
      width: '550px',
      data: null,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result) {
        let data = {
          deviceId: syncItem.tagDataQuery.deviceId,
          startTime:new Date(syncItem.tagDataQuery.startTime),
          endTime: new Date(syncItem.tagDataQuery.endTime),
          tags: syncItem.tagDataQuery.tags
        } 
        this.deviceInfoService.downloadTagsData(data, result, syncItem.deviceName);
        let syncUpdate = {
          id: syncItem.id,
          userId: syncItem.userId,
          syncStatus: "Closed"
        }
        this.deviceInfoService.updateSyncStatus(syncUpdate).subscribe((response:any) => {
          this.getOnDemandRequests();
        });
        
      }
    });
  }
}
